import useOnMountEffect from '../hooks/useOnMountEffect';
/* eslint-disable-next-line no-restricted-imports */
import { onLoaded } from './sentry/private/sentryBrowser';
import useLoadTracking from './useLoadTracking';

const SentryTracking = () => {
  const { load } = useLoadTracking();
  if (!load) {
    return null;
  }
  return <SentryWrapper />;
};

const SentryWrapper = () => {
  useOnMountEffect(() => {
    onLoaded();
  });
  return null;
};

export default SentryTracking;
